/**
 * Obstacle model for obstacles affecting operation at a takeoff/landing area.
 */
export class Obstacle {
  /**
   * Obstacle ID
   */
  obstacleId: number;

  /**
   * Takeoff/land area ID associated with this obstacle
   */
  takeoffLandAreaId: number;

  /**
   * Type of obstacle (e.g., "Trees", "Power-Line", "Building")
   */
  obstacleType: string;

  /**
   * Height of obstacle in feet AGL
   */
  heightAgl: number;

  /**
   * Distance of obstacle from end of runway (in feet)
   */
  distanceFromEnd: number;

  /**
   * Horizontal distance of obstacle from extended runway centerline (in feet)
   */
  centerlineOffset: number;

  /**
   * Horizontal offset direction of obstacle from extended runway centerline (e.g., "Left", "Right", "Both-Sides")
   */
  offsetDirection: string;

  /**
   * Approach slope necessary to clear the obstacle (in degrees)
   */
  clearanceSlope: number;

  /**
   * Obstacle marking
   */
  marking: string;

  /**
   * Parses obstacle
   * @param data {any} Obstacle data as returned by API
   * @return {Obstacle} Parsed obstacle
   */
  static parse(data: any): Obstacle {
    return {
      obstacleId: data.obstacleId,
      takeoffLandAreaId: data.takeoffLandAreaId,
      obstacleType: data.obstacleType,
      heightAgl: data.heightAgl,
      distanceFromEnd: data.distanceFromEnd,
      centerlineOffset: data.centerlineOffset,
      offsetDirection: data.offsetDirection,
      clearanceSlope: data.clearanceSlope,
      marking: data.marking
    };
  }
}
